/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import * as openEnums from "../../types/enums.js";
import { OpenEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as types from "../../types/primitives.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  TableConfig,
  TableConfig$inboundSchema,
  TableConfig$Outbound,
  TableConfig$outboundSchema,
} from "./tableconfig.js";

/**
 * The default visualization type for the equipment browser section
 */
export const DefaultVisualization = {
  Table: "table",
  Summary: "summary",
} as const;
/**
 * The default visualization type for the equipment browser section
 */
export type DefaultVisualization = OpenEnum<typeof DefaultVisualization>;

export type EquipmentBrowserSection = {
  /**
   * Whether the section should be expanded by default
   */
  defaultExpanded?: boolean | undefined;
  /**
   * The default visualization type for the equipment browser section
   */
  defaultVisualization?: DefaultVisualization | undefined;
  /**
   * The description of the equipment browser section
   */
  description?: string | undefined;
  /**
   * The id of the equipment browser section
   */
  id: string;
  /**
   * The name of the equipment browser section
   */
  name: string;
  /**
   * The order of items in the equipment browser section
   */
  order: Array<string>;
  /**
   * The table configurations in the equipment browser section
   */
  tables: Array<TableConfig>;
};

/** @internal */
export const DefaultVisualization$inboundSchema: z.ZodType<
  DefaultVisualization,
  z.ZodTypeDef,
  unknown
> = openEnums.inboundSchema(DefaultVisualization);
/** @internal */
export const DefaultVisualization$outboundSchema: z.ZodType<
  string,
  z.ZodTypeDef,
  DefaultVisualization
> = openEnums.outboundSchema(DefaultVisualization);

/** @internal */
export const EquipmentBrowserSection$inboundSchema: z.ZodType<
  EquipmentBrowserSection,
  z.ZodTypeDef,
  unknown
> = z.object({
  default_expanded: types.boolean().default(false),
  default_visualization: DefaultVisualization$inboundSchema.default("summary"),
  description: types.optional(types.string()),
  id: types.string(),
  name: types.string(),
  order: z.array(types.string()),
  tables: z.array(TableConfig$inboundSchema),
}).transform((v) => {
  return remap$(v, {
    "default_expanded": "defaultExpanded",
    "default_visualization": "defaultVisualization",
  });
});
/** @internal */
export type EquipmentBrowserSection$Outbound = {
  default_expanded: boolean;
  default_visualization: string;
  description?: string | undefined;
  id: string;
  name: string;
  order: Array<string>;
  tables: Array<TableConfig$Outbound>;
};

/** @internal */
export const EquipmentBrowserSection$outboundSchema: z.ZodType<
  EquipmentBrowserSection$Outbound,
  z.ZodTypeDef,
  EquipmentBrowserSection
> = z.object({
  defaultExpanded: z.boolean().default(false),
  defaultVisualization: DefaultVisualization$outboundSchema.default("summary"),
  description: z.string().optional(),
  id: z.string(),
  name: z.string(),
  order: z.array(z.string()),
  tables: z.array(TableConfig$outboundSchema),
}).transform((v) => {
  return remap$(v, {
    defaultExpanded: "default_expanded",
    defaultVisualization: "default_visualization",
  });
});

export function equipmentBrowserSectionToJSON(
  equipmentBrowserSection: EquipmentBrowserSection,
): string {
  return JSON.stringify(
    EquipmentBrowserSection$outboundSchema.parse(equipmentBrowserSection),
  );
}
export function equipmentBrowserSectionFromJSON(
  jsonString: string,
): SafeParseResult<EquipmentBrowserSection, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => EquipmentBrowserSection$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'EquipmentBrowserSection' from JSON`,
  );
}
